import React, { Component } from "react";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./EditorComponent.scss";

// DOCS: https://jpuri.github.io/react-draft-wysiwyg/#/docs

export default class EditorComponent extends Component {
	makeState = () => {
		if (!this.props.loadedText) {
			return {
				editorState: EditorState.createEmpty()
			};
		}
		const blocksFromHTML = convertFromHTML(this.props.loadedText);
		const state = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);

		return {
			editorState: EditorState.createWithContent(state)
		};
	};

	state = this.makeState();

	onEditorStateChange: Function = editorState => {
		this.setState({
			editorState
		});
		this.props.saveHTML(draftToHtml(convertToRaw(editorState.getCurrentContent())));
	};

	render() {
		const { editorState } = this.state;
		return (
			<div>
				<Editor
					editorState={editorState}
					wrapperClassName="editor-component-wrapper"
					editorClassName="editor-component"
					onEditorStateChange={this.onEditorStateChange}
					toolbar={{
						options: ["inline", "list", "colorPicker", "history"]
					}}
				/>
			</div>
		);
	}
}
